/**
 *
 * Ask
 *
 */

import { NoteContentModelMixin } from './model';

import NoteContent from '@/components/Note/Content.vue';

export const NoteContentMixin = {
  name: 'NoteContentMixin',

  mixins: [NoteContentModelMixin],

  components: {
    'note-content': NoteContent,
  },

  data: () => {
    return {
      allPromiseUploadImg: [],
    };
  },

  computed: {
    c_isNoteContentReady() {
      return !this.c_isNoteContentBlank;
    },
  },

  methods: {
    handleImageAdded({ allPromiseUploadImg }) {
      this.allPromiseUploadImg = allPromiseUploadImg;
    },

    //
    handleSave() {
      //
    },

    clearNoteContent() {
      this.noteContent = '';
    },
  },
};

export default NoteContentMixin;
